import React from 'react';

const RefundPolicy = () => {
  return (
    <div>
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <h1 className="hero-medium" style={{ marginBottom: '48px' }}>Refund & Cancellation Policy – Delhi Guided Tours</h1>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>1. Guest Cancellations</h2>
              <ul style={{ listStyle: 'disc', paddingLeft: '24px', margin: 0 }}>
                <li className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '8px' }}>
                  More than 24 hours before tour start: Full refund
                </li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '8px' }}>
                  12–24 hours before tour start: 50% refund
                </li>
                <li className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '8px' }}>
                  Less than 12 hours before tour start or no-show: No refund
                </li>
              </ul>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>2. Cancellations by Delhi Guided Tours</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                If a tour is cancelled due to weather, monument closure, or security reasons, guests will receive a full refund or rescheduling option.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>3. Private Tours</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Refund terms for private or customized tours are communicated at the time of booking.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>4. Refund Processing</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Approved refunds are processed within 5–7 business days to the original payment method.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicy;